import intelligenceV2Store from './store/index'
import registryIv2 from './ia/registry'
import { registrar } from './ui-registry'
import { registrarPlataforma } from './ui-registry/plataforma'

/**
 * Ponto de entrada do módulo — chamado por `src/modules/index.js` no boot
 * (`registerModules({ store })`), antes de qualquer rota renderizar.
 *
 * Duas coisas acontecem aqui, e as duas são "ligar o módulo à aplicação":
 * o store namespaced e, desde a spec-001 do `plataforma-por-chat` ([T017]), o
 * registry PARCIAL dos cartões deste módulo.
 *
 * ★ Por que o `registrar` mora aqui, e não no `ui-registry/index.js`
 *
 * O esboço do [T004] previa a agregação dentro do próprio `ui-registry`, por
 * import estático. Registrar no import tem um efeito colateral caro no teste:
 * QUALQUER suíte que importe o registry (o `chat-message.unit.js` é a maior)
 * passaria a começar com o agregado cheio, e os casos que montam entradas
 * controladas (`limparRegistry()` + `registrar({...})`) ficariam à mercê da
 * ordem de execução. Aqui o efeito é do BOOT, que é onde ele pertence: cada
 * módulo liga o seu parcial ao subir, exatamente como faz com o próprio store.
 */
export function aawzIntelligenceV2Module({ store }) {
  store.registerModule('aawz-intelligence-v2', intelligenceV2Store)
  registrar(registryIv2)
  // ★ [T015] O parcial da PLATAFORMA (as 4 tools de front + o cartão da ação
  // oferecida) entra por uma função própria, e não pelo `registrar` acima, por
  // um motivo de grafo de imports: os handlers puxam o catálogo de navegação
  // inteiro, e `ui-registry/index.js` é importado por `api/apiChat.js` — que
  // está na cadeia de `apiFeeFixoIa.js` (`extends APIChat`). Encostar o
  // catálogo nessa cadeia é o caminho de volta ao ciclo que derrubou 8 suítes
  // em 26/08 ([T010]). Aqui, no boot, ele fica fora dela.
  registrarPlataforma()
}
